import classnames from 'clsx';

import style from './style.module.css';

import type { CollapsibleListSectionSubHeaderComponent } from './collapsible-list-section-sub-header-types';

export const CollapsibleListSectionSubHeader: CollapsibleListSectionSubHeaderComponent = ({ children, className = null }) => {
  return <div className={classnames(style['collapsible-list-section-sub-header'], className)}>{children}</div>;
};
